export function AutomationEmptyState({ text }: { text: string }) {
  return (
    <div className="rounded-2xl border border-dashed border-stone-300 p-8 text-center text-sm text-stone-400 dark:border-white/10">
      {text}
    </div>
  );
}
